import React from 'react'

import PrismaZoom from 'react-prismazoom'

class PanMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scale: 1,
      translation: { x: 0, y: 0 },
      currentImage: ''
    }

    this.prismaZoom = React.createRef()
  }

  componentDidMount = () => {
    this.setState({
      currentImage: 'https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/' + (this.props.image.replaceAll(' ', '+'))
    })
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.image !== this.props.image) {
      this.setState({
        currentImage: 'https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/' + (this.props.image.replaceAll(' ', '+'))
      })
    }
  }

  render() {
    console.log(this.props.image);
    console.log(this.props.activeIllustratedMap);
    console.log(this.state.currentImage);
    return (
      <div className={this.props.activeIllustratedMap ? 'pan-map-container fade-in' : 'pan-map-container fade-out'}>
        <PrismaZoom
          className='prisma'
          ref={this.prismaZoom}
          style={{}}
          initialZoom={0.64}
          maxZoom={2}
          minZoom={0.64}
        >
          <div className='map-pan' style={{ backgroundImage: `url(${this.state.currentImage})` }}></div>
        </PrismaZoom>
      </div>
    )
  }
}

export default PanMap